<template>
  <div id="app" :class="appSkin">
    <router-view />
    <!--    <keep-alive>-->
    <!--      <router-view v-if="$route.meta.keepAlive" />-->
    <!--    </keep-alive>-->
    <!--    <router-view v-if="!$route.meta.keepAlive" />-->
  </div>
</template>
<script>
import { getToken, removeToken } from '@/utils/auth';
import { loadGoogleCaptchaV3Script } from '@/utils/captchaUtils';

export default {
  data() {
    return {
      appSkin: 'violet',
      time: 0,
      siteKey: '' // 谷歌验证key
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        if (route.path !== '/lock') {
          sessionStorage.setItem('lastHistory', route.path);
        }
      },
      immediate: true
    }
  },
  created() {
    this.siteKey = process.env.VUE_APP_RECAPTCHA_SITE_KEY;
    if (localStorage.getItem('themes')) {
      const checkTheme = JSON.parse(localStorage.getItem('themes'));
      this.appSkin = checkTheme.name;
    } else {
      this.appSkin = 'default';
    }

    // 检测是否从 UploadContas 页面进入首屏
    this.checkUploadContasEntry();
  },
  mounted() {
    // 动态加载谷歌验证码v3
    if (process.env.NODE_ENV === 'production') {
      loadGoogleCaptchaV3Script();
    }
    // 退出登录写进登录接口下
    // // sessionStorage.setItem('isLock', 1);
    // this.getCurrentTime();
    window.document.onmouseup = function() {
      const isToken = getToken();
      // console.log('token', isToken);
      if (!isToken && this.$router) {
        this.$router.replace({ path: '/login' });
      }
    };
  },
  methods: {
    getCurrentTime() {
      const overTime = new Date().getTime();
      sessionStorage.setItem('overTime', overTime);

      // console.log('查看调用--开始计时');
      this.time = setTimeout(() => {
        removeToken();
        this.$router.replace({ path: '/login' });
        // this.checkTimeout();
        // console.log('查看调用--超时清除');
        clearTimeout(this.time);
      }, 12 * 60 * 60 * 1000);
    },
    checkTimeout() {
      const timeOut = 12 * 60 * 60 * 1000;
      const currentTime = new Date().getTime(); // 更新当前时间
      const lastTime = sessionStorage.getItem('overTime');
      if (currentTime - lastTime > timeOut) {
        // 判断是否超时
        // setTimeout(() => {
        //   if (!localStorage.getItem('UnlockScreen') || localStorage.getItem('UnlockScreen') === 'false') {
        //     this.$router.replace({ path: '/lock' });
        //   }
        // }, 500);
      }
    },
    // 检测是否从 UploadContas 页面进入首屏
    checkUploadContasEntry() {
      const targetPath = '/finance/payableManagement/UploadContas';
      const currentPath = window.location.pathname;
      const searchParams = new URLSearchParams(window.location.search);

      // 判断路径是否匹配（忽略大小写）
      if (currentPath.toLowerCase() === targetPath.toLowerCase()) {
        const payableNumber = searchParams.get('payableNumber');
        const timeStamp = searchParams.get('timeStamp');

        // 存储标识和参数到 localStorage
        localStorage.setItem('isFromUploadContas', 'true');
        if (payableNumber) {
          localStorage.setItem('uploadContasPayableNumber', payableNumber);
        }
        if (timeStamp) {
          localStorage.setItem('uploadContasTimeStamp', timeStamp);
        }
      }
    }
  }
};
</script>
<style lang="scss">
.el-submenu__title i {
  color: inherit;
}

.el-select-dropdown {
  //min-width: 0 !important;
  //width: 20%;
}

#app.default {
  background: #f5f8f7;

  .app-wrapper,
  .main-container {
    background: #f5f8f7;
  }
}

#app.redBlue {
  .sidebar-container {
    .sidebar-logo-container {
      background-color: #f00;
    }

    .el-scrollbar,
    .el-submenu__title,
    .el-menu-item {
      background-color: #00a551 !important;
    }

    .el-menu-item:hover,
    .nest-menu .el-submenu > .el-submenu__title:hover,
    .el-submenu .el-menu-item:hover,
    .el-submenu__title:hover {
      background-color: #008f47 !important;
    }

    .nest-menu .el-submenu > .el-submenu__title,
    .el-submenu .el-menu-item {
      background-color: #00783d !important;
    }

    .is-active {
      color: #ffda00 !important;
    }
  }

  .navbar {
    background: #f00;
  }

  .navbar * {
    color: #fff !important;
  }

  .navbar .msgNumCon {
    background: #e6a23c !important;
  }
}

#app.blueRed {
  .sidebar-container {
    .sidebar-logo-container {
      background-color: #00a551;
    }

    .el-scrollbar,
    .el-submenu__title,
    .el-menu-item {
      background-color: #00a551 !important;
    }

    .el-menu-item:hover,
    .nest-menu .el-submenu > .el-submenu__title:hover,
    .el-submenu .el-menu-item:hover,
    .el-submenu__title:hover {
      background-color: #008f47 !important;
    }

    .nest-menu .el-submenu > .el-submenu__title,
    .el-submenu .el-menu-item {
      background-color: #00783d !important;
    }

    .is-active {
      color: #ffda00 !important;
    }
  }

  .navbar {
    background: #f00;
  }

  .navbar * {
    color: #fff !important;
  }

  .navbar .msgNumCon {
    background: #e6a23c !important;
  }
}

#app.luxuryGold {
  .sidebar-container {
    .sidebar-logo-container {
      background-color: #c33f06;
    }

    .el-scrollbar,
    .el-submenu__title,
    .el-menu-item {
      color: #fff !important;
      background-color: #f57842 !important;
    }

    .el-menu-item:hover,
    .nest-menu .el-submenu > .el-submenu__title:hover,
    .el-submenu .el-menu-item:hover,
    .el-submenu__title:hover {
      background-color: #96340a !important;
    }

    .nest-menu .el-submenu > .el-submenu__title,
    .el-submenu .el-menu-item {
      background-color: #9e3b11 !important;
    }

    .is-active {
      color: #ffda00 !important;
    }
  }

  .navbar {
    background: #aaa;
  }

  .navbar * {
    color: #fff !important;
  }
}

#app.green {
  .sidebar-container {
    .sidebar-logo-container {
      background-color: #026502;
    }

    .el-scrollbar,
    .el-submenu__title,
    .el-menu-item {
      color: #fff !important;
      background-color: green !important;
    }

    .el-menu-item:hover,
    .nest-menu .el-submenu > .el-submenu__title:hover,
    .el-submenu .el-menu-item:hover,
    .el-submenu__title:hover {
      background-color: #014e01 !important;
    }

    .nest-menu .el-submenu > .el-submenu__title,
    .el-submenu .el-menu-item {
      background-color: #016101 !important;
    }

    .is-active {
      color: #ffda00 !important;
    }
  }

  .navbar {
    background: #aaa;
  }

  .navbar * {
    color: #fff !important;
  }
}

#app.violet {
  .sidebar-container {
    .sidebar-logo-container {
      background-color: #bc03cb;
    }

    //.sidebar-title{
    //  color: #000;
    //}
    .el-scrollbar,
    .el-submenu__title,
    .el-menu-item {
      color: #fff !important;
      background-color: #e303f5 !important;
    }

    .el-menu-item:hover,
    .nest-menu .el-submenu > .el-submenu__title:hover,
    .el-submenu .el-menu-item:hover,
    .el-submenu__title:hover {
      background-color: #9503a2 !important;
    }

    .nest-menu .el-submenu > .el-submenu__title,
    .el-submenu .el-menu-item {
      background-color: #9d06ab !important;
    }

    .is-active {
      color: #03f51c !important;
    }
  }

  .navbar {
    background: #aaa;
  }

  .navbar * {
    color: #fff !important;
  }
}

//  主题暂时这样替换，后续使用js 进行动态处理
#app.ui {
  .sidebar-container {
    .sidebar-logo-container {
      background-color: #2b2f3a;
    }

    //.sidebar-title{
    //  color: #000;
    //}
    .el-scrollbar,
    .el-submenu__title,
    .el-menu-item {
      color: #fff !important;
      background-color: #37547d !important;
    }

    .el-menu-item:hover,
    .nest-menu .el-submenu > .el-submenu__title:hover,
    .el-submenu .el-menu-item:hover,
    .el-submenu__title:hover {
      background-color: #001528 !important;
    }

    .nest-menu .el-submenu > .el-submenu__title,
    .el-submenu .el-menu-item {
      background-color: #1f2d3d !important;
    }

    .is-active {
      // color: #fff!important;
      color: #00a551 !important;
    }
  }

  .navbar {
    background: #2b2f3a;
  }

  .navbar * {
    // color: #fff!important;
    color: #bfcbd9 !important;
  }
}

// 第六批品牌布局兜底：历史主题只保留业务兼容，不再覆盖新后台壳层。
#app.default,
#app.redBlue,
#app.blueRed,
#app.luxuryGold,
#app.green,
#app.violet,
#app.ui {
  .app-wrapper,
  .main-container {
    background: #f7f8fa !important;
  }

  .fixed-header,
  .navbar,
  .tags-view-container {
    background: #ffffff !important;
  }

  .navbar {
    color: #1d2129 !important;
  }

  .navbar .navbar-action,
  .navbar .navbar-action__icon,
  .navbar .hamburger-container,
  .navbar .user-pill__arrow {
    color: #4e5969 !important;
  }

  .navbar .navbar-action:hover,
  .navbar .navbar-action:hover .navbar-action__icon,
  .navbar .hamburger-container:hover {
    color: #00a551 !important;
  }

  .navbar .imgs_box p:nth-child(1),
  .navbar .message-date {
    color: #86909c !important;
  }

  .navbar .imgs_box p:nth-child(2),
  .navbar .app-breadcrumb .no-redirect {
    color: #1d2129 !important;
  }

  .navbar .app-breadcrumb a:hover {
    color: #00a551 !important;
  }

  .sidebar-container {
    background: #ffffff !important;

    .sidebar-logo-container,
    .el-scrollbar {
      color: #4b5563 !important;
      background-color: transparent !important;
    }

    .sidebar-logo-container {
      background: #ffffff !important;
    }

    .el-submenu__title,
    .el-menu-item,
    .nest-menu .el-submenu > .el-submenu__title,
    .el-submenu .el-menu-item {
      color: #4b5563 !important;
    }

    .el-menu-item:hover,
    .nest-menu .el-submenu > .el-submenu__title:hover,
    .el-submenu .el-menu-item:hover,
    .el-submenu__title:hover {
      color: #111827 !important;
      background-color: #f9fafb !important;
    }

    .is-active > .el-submenu__title,
    .el-submenu.is-active > .el-submenu__title,
    .nest-menu .el-submenu.is-active > .el-submenu__title {
      color: #111827 !important;
      background: transparent !important;
    }

    .el-menu-item.is-active,
    .el-submenu .el-menu-item.is-active {
      color: #00a933 !important;
      background: rgba(0, 169, 51, 0.05) !important;
    }
  }
}
</style>
